/* Copyright (c) 2024 Xperi. All Rights Reserved. */

// eslint-disable-next-line no-shadow
export enum UIOrchestratorState {
    BOOKMARK_CREATED,
    BOOKMARK_TEMP_DELETED,
    BOOKMARK_DELETION_FAILED,
    BOOKMARK_DELETED,
    DATA_LOADED,
    FETCHING_DATA,
    ONE_PASS_CREATED,
    ONE_PASS_DELETED,
    ONE_PASS_MODIFIED,
    RECORDING_CREATED,
    NEW_SCREEN_MOUNTED,
    RECORDING_TEMP_DELETED,
    RECORDING_DELETION_FAILED,
    RECORDING_DELETED,
    RECORDING_MODIFIED,
    RECORDING_RECOVERED,
    RECORDING_PERSISTENCE_MODIFIED,
    JUMP_CHANNEL_SHOW_OVERLAY,
}
